import { BaseResource } from '../../../base-resource';
import { Package } from 'src/modules/models/booking/package';
import { BookingItem } from './booking-item';
export class Booking extends BaseResource {
    constructor() {
        super();  
        this.type = "Booking";
    
    }
     
    confirmedDate: string;
    cancelled: boolean;
    confirmed: boolean;
    salesChannelId: number;
    bookingStatus: BookingStatus;
    contact: Contact
    bookingPackages: BookingPackage[]; 
    priceConcession: PriceConcession;
    temporary: boolean;
    seasonId :number;
    bookingTypeId: number;
    eventName: string;
}

export class BookingStatus extends BaseResource {
    constructor() {
        super();
        this.type = "BookingStatus";

    }
}
export class Contact extends BaseResource {
    constructor() {
        super();
        this.type = "Contact";

    }
    client: Client;
}
export class Client extends BaseResource {
    constructor() {
        super();
        this.type = "Client";

    }
    priceConcessionId: string;
}

export class BookingPackage extends BaseResource {
    constructor() {
        super();
        this.type = "BookingPackage";

    }
    name:string;
    attendees:number;
    quantity: number;
    package: Package;
    startDate: string;
    endDate: string;
    bookingItems: BookingItem[]

}
export class PriceConcession extends BaseResource {
    constructor() {
        super();
        this.type = "PriceConcession";

    }
}